import { type EventMappers, registerGa4Events } from '../../tracking/dataLayerAdapter';
import type { MobileUsageVariant } from './homeNetwork';

declare module '@platform/tracking' {
  interface TrackingEvents {
    home_network_viewed: { has_home_zone: boolean; mobile_usage_variant: MobileUsageVariant };
    home_network_app_download_opened: { store: 'apple' | 'google-play' };
    home_network_how_it_works_expanded: { channel_group: string };
    home_network_mobile_usage_upsell_clicked: Record<string, never>;
  }
}

export const homeNetworkGa4EventMappers: EventMappers = {
  home_network_viewed: (p) => ({
    event: 'home_network',
    event_description: 'home_network_viewed',
    has_home_zone: p.has_home_zone,
    mobile_usage_variant: p.mobile_usage_variant,
  }),
  home_network_app_download_opened: (p) => ({
    event: 'home_network',
    event_description: 'home_network_app_download_opened',
    store: p.store,
  }),
  home_network_how_it_works_expanded: (p) => ({
    event: 'home_network',
    event_description: 'home_network_how_it_works_expanded',
    channel_group: p.channel_group,
  }),
  home_network_mobile_usage_upsell_clicked: () => ({
    event: 'home_network',
    event_description: 'home_network_mobile_usage_upsell_clicked',
  }),
};

registerGa4Events(homeNetworkGa4EventMappers);
